export default "__VITE_ASSET__BW_Zvrl8__"